import { useTranslation } from 'react-i18next';

import EmptyState from '../../../../../shared/components/Globals/EmptyState/EmptyState';
import { TRANSLATIONS_QUOTES } from '../../../../../shared/translations/quotes';
import './NoProductsAvailableSection.scss';

const NoProductsAvailableSection = () => {
  const { t } = useTranslation();

  return (
    <section className="quote-no-products">
      <EmptyState
        title={t(TRANSLATIONS_QUOTES.create.emptyState.title)}
        description={t(TRANSLATIONS_QUOTES.create.emptyState.description)}
      />
    </section>
  );
};

export default NoProductsAvailableSection;
